export const VerificationAgencyBase = `VerificationAgency`;
export const UploadBase = 'Upload';

export const ExportVAPack = VerificationAgencyBase + '/ExportVAPack';
export const GetVAPack = UploadBase + '/CreateVerificationFile';

export const SearchVAExcelExports = VerificationAgencyBase + '/SearchVAExcelExports';
export const DownloadVAExcelExport = VerificationAgencyBase + '/DownloadVAExcelExport';

export const CheckVAExportInProgress = VerificationAgencyBase + '/CheckVAExportInProgress';